import React, { Component } from "react";
import { hideLoadingScreen } from "@/modules/loading";

export default class ImportDemo extends Component {
	state = {
		ewe: null,
		ewe2: null
	};

	componentDidMount() {
		hideLoadingScreen();
	}
	
	handleClick = () => {
		const ID = this;
		
		import("./OtherComponent")
		.then((Module) => {
			ID.setState({ewe : React.createElement(Module.default)});
		});
	}
	
	render() {
		return (
			<div>
				<button onClick={this.handleClick}>
					Load
				</button>
				
				{ this.state.ewe }
				{ this.state.ewe2 }
			</div>
		);
	}
}

/* // WORKS
import React, { Component } from "react";
import {
	hideLoadingScreen,
} from "@/modules/commonMobile";

export default class ImportDemo extends Component {
	constructor() {
		super();
		
		this.state = {};
		
		hideLoadingScreen();
	}
	
	handleClick = () => {
		const ID = this;
		
		import("./OtherComponent")
		.then(( Module ) => {
			console.log("Huee", React.createElement(Module.default), "Mdr", Module.default.render );
			ID.setState( {ewe : React.createElement(Module.default)} );
		});
	}
	
	render() {
		return (
			<div>
				<button onClick={this.handleClick}>
					Load
				</button>
				
				{ this.state.ewe }
			</div>
		);
	}
} */

/*
FAILED TO LOAD

import React from "react";
import loadable from '@loadable/component'

const OtherComponent = loadable(() => import('./OtherComponent')).render();

function MyComponent() {
  return (
	<div>
		<OtherComponent />
	</div>
  )
}

const ImportDemo = () => (
	MyComponent();
);

export default ImportDemo; */